import { useEffect, useState } from "react"
import { Label, Slider } from "@ui/shad"
import { cn } from "@ui/utils"

interface SliderInputProps {
  id: string
  value?: number
  onChange?: (value: number) => void
  onCommit?: (value: number) => void
  label?: string
  error?: boolean
  disabled?: boolean
  min?: number
  max?: number
  step?: number
  showValue?: boolean
  formatValue?: (value: number) => string
}

export function SliderInput({
  value = 0,
  onChange,
  onCommit,
  label,
  error,
  disabled = false,
  id,
  min = 0,
  max = 100,
  step = 1,
  showValue = true,
  formatValue = (value) => value.toString(),
}: SliderInputProps) {
  const [localValue, setLocalValue] = useState(value)

  // Sync with prop updates
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleChange = (values: number[]) => {
    const newValue = values[0]
    setLocalValue(newValue)
    onChange?.(newValue)
  }

  return (
    <div className="space-y-2">
      <div className="flex justify-between">
        {label && (
          <Label htmlFor={id} className={cn(error && "text-destructive")}>
            {label}
          </Label>
        )}
        {showValue && <span className="text-muted-foreground text-sm">{formatValue(localValue)}</span>}
      </div>
      <Slider
        id={id}
        value={[localValue]}
        onValueChange={handleChange}
        onValueCommit={(values) => onCommit?.(values[0])}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
      />
    </div>
  )
}
